module.exports = __webpack_public_path__ + "img/svg/step3.b7ee4fc9108090452a706ad4a1ea8fda.svg";